$('.scroll-arrow svg').on('click', ()=>{
	$([document.documentElement, document.body]).animate({
        scrollTop: ($('.scroll-arrow').offset().top + 50)
    }, 600);
});

